import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { LoaderProps } from './';

const ellipsis1 = keyframes`
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
`;

const ellipsis2 = keyframes`
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(19px, 0);
    }
`;

const ellipsis3 = keyframes`
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
`;

const UpscoreDot = css`
    background: #54ef93;
`;

const FormueDot = css`
    background: #133143;
`;

export const StyledDot = styled.span`
    width: 11px;
    height: 11px;

    position: absolute;
    top: 27px;

    border-radius: 50%;

    animation-timing-function: cubic-bezier(0, 1, 1, 0);

    &:nth-of-type(1) {
        left: 6px;

        animation: ${ellipsis1} 0.6s infinite;
    }

    &:nth-of-type(2) {
        left: 6px;

        animation: ${ellipsis2} 0.6s infinite;
    }

    &:nth-of-type(3) {
        left: 26px;

        animation: ${ellipsis2} 0.6s infinite;
    }

    &:nth-of-type(4) {
        left: 45px;

        animation: ${ellipsis3} 0.6s infinite;
    }

    ${(props) => props.theme.version === 'upscore' && UpscoreDot}
    ${(props) =>
        props.theme.version === 'formue' ||
        (props.theme.version === 'pengestyrke' && FormueDot)}
`;

const StyledLoaderCentered = css`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const StyledLoader = styled.div<LoaderProps>`
    display: inline-block;

    width: 64px;
    height: 64px;

    position: relative;

    ${(props) => props.centered && StyledLoaderCentered}
`;

export const FullPageLoaderWrapper = styled.div`
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
`;
